/* eslint-disable */
import { AnyAction, Reducer } from 'redux'
import { toast } from 'react-toastify'
import { call, put, takeLatest, all } from 'redux-saga/effects'
import { SagaAction, GetResponse } from 'src/@types'
import { API } from 'src/services/config'
import { AnimalProps } from 'src/@types/Animal'
import { ILotProps } from './lots'
import { ISaleProps } from './sale'
import { ICoverageProcessProps } from './coverageProcess'
import { IAnimal } from 'src/dto/animal.dto'

export interface IDeathsAndDiseasesProps {
  id: string
  idAnimal?: string
  observacao?: string
  data: string
  animal: string | null
  ocorrencia: string | null
  causa: string | null
}

export interface IAnimalRecord {
  tabela: 'Animal' | 'AnimalHistorico' | 'AnimalImagem'
  idAnimal?: string
  bodyRequest: IAnimal
  objectOrigem: IAnimal | null
}

export interface IDeathsAndDiseasesRecord {
  tabela: 'Morte'
  bodyRequest: IDeathsAndDiseasesProps
  objectOrigem: IDeathsAndDiseasesProps | null
}

export interface ISaleRecord {
  tabela: 'VendaAnimal'
  bodyRequest: ISaleProps
  objectOrigem: ISaleProps | null
}

export interface ILotRecord {
  tabela: 'Lote'
  bodyRequest: ILotProps
  objectOrigem: ILotProps | null
}

export interface ICoverageProcessRecord {
  tabela: 'ProcessoCobertura'
  bodyRequest: ICoverageProcessProps
  objectOrigem: ICoverageProcessProps | null
}

// Union type com discriminated union
export type IPendingRecord<
  T = IAnimalRecord | IDeathsAndDiseasesRecord | ISaleRecord | ILotRecord | ICoverageProcessRecord
> = T & {
  idFazenda: string
  idMovementValidationTable: string
  userRequest: string
  dataCreation: string
  userAproved: string
  dateAproved: string
  status: 'Processado' | 'Aguardando' | 'Rejeitado'
}

interface IUpdatePendingRecordProps {
  data: IPendingRecord
  onSuccess?: () => void
}

export interface PendingRecordsState {
  loading: boolean
  list: Array<IPendingRecord>
  peddingRecordsCount: number | null
}

const customModule = '@PENDING_RECORDS'

const GET = {
  REQUEST: `${customModule}/GET_REQUEST`,
  SUCCESS: `${customModule}/GET_SUCCESS`,
  FAILED: `${customModule}/GET_FAILED`
}

const UPDATE = {
  REQUEST: `${customModule}/UPDATE_REQUEST`,
  SUCCESS: `${customModule}/UPDATE_SUCCESS`,
  FAILED: `${customModule}/UPDATE_FAILED`
}

const initialState: PendingRecordsState = {
  loading: true,
  list: [],
  peddingRecordsCount: null
}

export const pendingRecordsReducer: Reducer<PendingRecordsState, AnyAction> = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case GET.REQUEST:
      return { ...state, loading: true }
    case GET.SUCCESS:
      const peddingRecordsCount = payload.filter((record: IPendingRecord) => record.status === 'Aguardando').length
      return { ...state, list: payload, peddingRecordsCount, loading: false }
    case GET.FAILED:
      return { ...state, loading: false, peddingRecordsCount: null }
    case UPDATE.REQUEST:
      return { ...state, loading: true }
    case UPDATE.SUCCESS:
      return { ...state, loading: false }
    case UPDATE.FAILED:
      return { ...state, loading: false }
    default:
      return state
  }
}

export const getPendingRecords = (farmId: string) => ({ type: GET.REQUEST, payload: { farmId } })
export const updatePendingRecords = (payload: any) => ({
  type: UPDATE.REQUEST,
  payload
})

const ROUTE = '/tabelaMovimentacaoValidacao'

// eslint-disable-next-line
function* get({ payload }: SagaAction<{ farmId: string }>) {
  try {
    const { farmId } = payload
    const { data }: GetResponse<any> = yield call(API.get, `${ROUTE}/${farmId}`)
    yield put({ type: GET.SUCCESS, payload: data })
  } catch (error: any) {
    yield put({ type: GET.FAILED })
    const message = 'Erro ao buscar lista de pelagem.'
    toast.error(message)
    console.error(error)
  }
}

// eslint-disable-next-line
function* update({ payload }: SagaAction<IUpdatePendingRecordProps>) {
  try {
    const { data: payloadData, onSuccess } = payload

    const { data }: GetResponse<IPendingRecord> = yield toast.promise(
      API.put(`${ROUTE}/${payloadData.idFazenda}`, [payloadData]),
      {
        pending: 'Processando...',
        success: {
          render() {
            return 'Atualizado com Sucesso!'
          },
          delay: 800
        },
        error: {
          render({ data: { response } }: any) {
            return response?.data || 'Erro ao Atualizar'
          },
          delay: 800
        }
      }
    )
    yield put({ type: UPDATE.SUCCESS, payload: data })
    yield put({ type: GET.REQUEST, payload: { farmId: payloadData.idFazenda } })

    if (onSuccess) onSuccess()
  } catch {
    yield put({ type: UPDATE.FAILED })
  }
}

export const PendingRecordsSaga = all([takeLatest(GET.REQUEST, get), takeLatest(UPDATE.REQUEST, update)])
